/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Locations/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import More from './More/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Locations({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/BasicInformation/Locations"
  
}) {
let locations0NameValueData = fromData.useDataValue({ viewPath,
context: 'locations',
path: '[0].name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="locations.[0].name"
 text={locations0NameValueData}
/>
<More
  viewPath={`${viewPath}/More`}
/>
{children}
</React.Fragment>)
}